export interface ColumnDef {
  id: string
  label: string
  defaultWidth: number
  minWidth: number
  sortable: boolean
  sortType: 'text' | 'number' | 'date' | 'step-sequence' | 'none'
  hideable: boolean
  defaultHidden: boolean
}

export const COLUMN_DEFS: ColumnDef[] = [
  { id: 'cb', label: '', defaultWidth: 32, minWidth: 32, sortable: false, sortType: 'none', hideable: false, defaultHidden: false },
  { id: 'expand', label: '', defaultWidth: 20, minWidth: 20, sortable: false, sortType: 'none', hideable: false, defaultHidden: false },
  { id: 'id', label: 'ID', defaultWidth: 140, minWidth: 96, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'product', label: 'Product', defaultWidth: 240, minWidth: 120, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'sku', label: 'SKU', defaultWidth: 120, minWidth: 80, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'customer', label: 'Customer', defaultWidth: 110, minWidth: 80, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'path', label: 'Request', defaultWidth: 64, minWidth: 52, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'priority', label: 'Priority', defaultWidth: 72, minWidth: 60, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'step', label: 'Open Steps', defaultWidth: 180, minWidth: 100, sortable: true, sortType: 'step-sequence', hideable: true, defaultHidden: false },
  { id: 'assignee', label: 'Assignee', defaultWidth: 110, minWidth: 80, sortable: true, sortType: 'text', hideable: true, defaultHidden: false },
  { id: 'complexity', label: 'Complexity', defaultWidth: 80, minWidth: 64, sortable: true, sortType: 'number', hideable: true, defaultHidden: false },
  { id: 'initiative', label: 'Initiative', defaultWidth: 130, minWidth: 80, sortable: true, sortType: 'text', hideable: true, defaultHidden: true },
  { id: 'submitted', label: 'Submitted', defaultWidth: 80, minWidth: 64, sortable: true, sortType: 'date', hideable: true, defaultHidden: false },
  { id: 'due', label: 'Due', defaultWidth: 64, minWidth: 52, sortable: true, sortType: 'date', hideable: true, defaultHidden: false },
  { id: 'age', label: 'Age', defaultWidth: 52, minWidth: 44, sortable: true, sortType: 'number', hideable: true, defaultHidden: false },
  { id: 'quote', label: 'Proof Packet', defaultWidth: 150, minWidth: 120, sortable: false, sortType: 'none', hideable: true, defaultHidden: false },
]

export const COLUMN_BY_ID = Object.fromEntries(COLUMN_DEFS.map((c) => [c.id, c]))

export function buildGridTemplate(
  order: string[],
  hidden: Record<string, true>,
  widths: Record<string, number>
): string {
  return order
    .filter((id) => !hidden[id])
    .map((id) => {
      const w = widths[id] ?? COLUMN_BY_ID[id]?.defaultWidth ?? 80
      return `${w}px`
    })
    .join(' ')
}
